import React from "react";
import analytics from "@xo-union/tk-analytics";
import getMappableValue from "../getMappableValue.js";
export const useTrackImpression = _ref => {
  let {
    eventName,
    ...eventData
  } = _ref;
  React.useEffect(() => {
    analytics.track(eventName, eventData); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

const trackImpression = propMap => {
  const decorator = DecoratedComponent => {
    const ImpressionTracker = props => {
      const event = getMappableValue(propMap, props);
      useTrackImpression(event);
      return /*#__PURE__*/React.createElement(DecoratedComponent, props);
    };

    return ImpressionTracker;
  };

  return decorator;
};

export default trackImpression;